export default "__VITE_ASSET__gwAI5zLX__"